import { FC, lazy, Suspense } from 'react';
import { PdpSharedDetail, PdpSharedDetailProps } from '../shared/PdpSharedDetail/PdpSharedDetail';

type Props = PdpSharedDetailProps & {
    isClient: boolean;
};

export const PdpSharedDetailLabReport: FC<Props> = ({ isClient, ...props }) => {
    const LabReportTip = lazy(
        () =>
            import(
                /* webpackChunkName: "PdpSharedDetailLabReportTip" */ '../shared/PdpSharedDetail/PdpSharedDetailLabReportTipLazy'
            )
    );

    return (
        <>
            <PdpSharedDetail {...props} />
            {isClient && (
                <Suspense fallback="">
                    <LabReportTip />
                </Suspense>
            )}
        </>
    );
};
